import { Component, OnInit } from '@angular/core';
import { ComponentBase } from 'src/app/main/dynamic/component-base';


@Component({
  selector: 'app-calc',
  templateUrl: './calc.component.html'
})
export class CalcComponent extends ComponentBase implements OnInit {

  prefixo: string = " ";

  ngOnInit(): void {
    let prefixOption = this.attribute.options
      .find(opt => opt.key.toLowerCase() == "prefix-mask")

    if (prefixOption)
      this.prefixo = prefixOption.value;        

    // if (this.eventSubscriber) {
    //   this.eventSubscriber.subscribe((attributeChanged: any) => {

    //     let attribute = this.attribute.attributes.find(a => a.key == "Calc " + attributeChanged.key);

    //     if (attribute) {

    //       attribute.value = attributeChanged.value;

    //       this.recalcular();
    //     }

    //   });
    // }
  }

  recalcular() {
    let expression = '';

    this.attribute.attributes.forEach(element => {
      expression += element.value;
    })

    try {
      this.attribute.value = eval(expression);
    } catch (error) {
      this.attribute.value = null;
    }
  }
}